export default "__VITE_ASSET__DM_C3FUr__"